import { create } from "zustand";
import type { Design, ProductTemplate, Mockup } from "@pod-mockup/shared";

interface AppState {
  currentDesign: Design | null;
  setCurrentDesign: (design: Design | null) => void;

  templates: ProductTemplate[];
  setTemplates: (templates: ProductTemplate[]) => void;
  selectedTemplate: ProductTemplate | null;
  setSelectedTemplate: (template: ProductTemplate | null) => void;

  editorState: {
    posX: number;
    posY: number;
    scale: number;
    rotation: number;
  };
  setEditorState: (state: Partial<AppState["editorState"]>) => void;

  mockups: Mockup[];
  addMockup: (mockup: Mockup) => void;
  updateMockup: (id: string, updates: Partial<Mockup>) => void;

  isUploading: boolean;
  setIsUploading: (v: boolean) => void;
  isGenerating: boolean;
  setIsGenerating: (v: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  currentDesign: null,
  setCurrentDesign: (design) => set({ currentDesign: design }),

  templates: [],
  setTemplates: (templates) => set({ templates }),
  selectedTemplate: null,
  setSelectedTemplate: (template) => set({ selectedTemplate: template }),

  editorState: {
    posX: 0,
    posY: 0,
    scale: 1,
    rotation: 0,
  },
  setEditorState: (state) =>
    set((prev) => ({ editorState: { ...prev.editorState, ...state } })),

  mockups: [],
  addMockup: (mockup) => set((prev) => ({ mockups: [...prev.mockups, mockup] })),
  updateMockup: (id, updates) =>
    set((prev) => ({
      mockups: prev.mockups.map((m) => (m.id === id ? { ...m, ...updates } : m)),
    })),

  isUploading: false,
  setIsUploading: (v) => set({ isUploading: v }),
  isGenerating: false,
  setIsGenerating: (v) => set({ isGenerating: v }),
}));
